import { render, staticRenderFns } from "./rol-modulo-permiso.vue?vue&type=template&id=4f35cfa3"
import script from "./rol-modulo-permiso.vue?vue&type=script&lang=js"
export * from "./rol-modulo-permiso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports